{
	"approveContract": "Approve contract",
	"description": "You have pending agreements.",
	"deselectAllContracts": "Deselect all contracts",
	"modalApproveConfirmation": {
		"description": "To finalize the subscription and confirm the approval, we will send a code to the registered email. At the end of the subscription, you will only be able to cancel by contacting the support channel.",
		"header": "Approval confirmation",
		"reminder": "Reminder: check your spam folder, the email with the code may have been directed to it.",
		"sendCode": "Send code"
	},
	"modalCodeConfirmation": {
		"codePlaceholder": "Enter the code sent",
		"confirmSign": "Confirm subscription",
		"description": "Enter confirmation code to complete request signing.",
		"verifyCode": "Confirmation code"
	},
	"request": "Request #{{request}}",
	"selectAllContracts": "Select all contracts",
	"title": "Pending terms and contracts"
}
